import type { FeatureRoute } from '../types';
import { DataHubPage } from './DataHubPage';
import { ImportPage } from './ImportPage';

/** Routes owned by this feature (paths are relative to the app root). */
export const routes: FeatureRoute[] = [
  { path: 'data', element: <DataHubPage /> },
  { path: 'data/import/:model', element: <ImportPage /> },
];
